import React from "react";
import Paginator from "./../shared/paginator.jsx";
import moment from "moment";
import context from "./../../lib/context.js";
import { browserHistory } from "react-router";
import ajax from "./../../lib/ajax.js";

export default class RequestList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            resources: {}
        }

        this.onHeaderClick = this.onHeaderClick.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
        this.onCopyClick = this.onCopyClick.bind(this);
        this.loadResources = this.loadResources.bind(this);
    }

    componentDidMount() {
        this.loadResources();
    }

    loadResources() {
        const self = this;

        ajax.vm()
            .get(`request-list-resources`)
            .then(function (res) {
                self.setState({ resources: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                if (data.exceptionMessage && data.exceptionMessage.toLowerCase().indexOf("unauthorize") > -1) {
                    browserHistory.push(context.routeUrl(`home`));
                }
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
    }

    onHeaderClick(event) {
        if (this.props.onSort) {
            var sortExpression = event.target.getAttribute('type');

            if (this.props.search.sortExpression.indexOf(sortExpression) > -1) {
                if (this.props.search.sortExpression.indexOf(' desc') < 0)
                    sortExpression = sortExpression + ' desc';
            }

            this.props.onSort(sortExpression);
        }
    }

    onRowClick(event) {
        if (event.target.tagName.toUpperCase() == 'TR') {
            browserHistory.push(context.routeUrl(`${this.props.role}/request-entry/${event.target.getAttribute("name")}`));
        }
        else if (event.target.tagName.toUpperCase() == 'TD') {
            browserHistory.push(context.routeUrl(`${this.props.role}/request-entry/${event.target.parentElement.getAttribute("name")}`));
        }
    }

    onEditClick(event) {
        browserHistory.push(context.routeUrl(`${this.props.role}/request-entry/${event.target.getAttribute("name")}`));
        event.stopPropagation();
    }
        
    onCopyClick(event) {
        browserHistory.push(context.routeUrl(`${this.props.role}/request-copy/${event.target.getAttribute("name")}`));
        event.stopPropagation();
    }

    render() {
        let items = [];

        let vm = this.props.vm; // Expected to be an array of listItem
        let totalPage = vm.total / vm.pageSize + 
            (vm.total % vm.pageSize > 0 ? 1 : 0); 

        if (vm == null || vm.requests == null || vm.requests == 0) {
            return(
                <div className="ap-fullsize ap-grid-result text-center">
                    {this.state.resources.NoRequestFound}
                </div>
                );
        } else {
            for(let i=0; i<vm.requests.length; i++) {
                let request = vm.requests[i].requestSummary? vm.requests[i].requestSummary: vm.requests[i]; // check first if result came from Legacy API
                let enableEdit = this.props.role == 'supervisor' && (request.status == 'RETURNED_MANAGER' || request.status == 'SAVED');
                let icon = this.props.statuses.filter(x => x.code == request.status);

                if (icon.length > 0)
                    icon = icon[0].icon;
                else
                    icon = null;

                items.push(
                    <tr name={request.requestID} onClick={this.onRowClick} className="ap-clickable" >
                        <td>{request.requestID}</td>
                        <td>{request.requestedDate != null ? moment(request.requestedDate).format("MM/DD/YYYY") : ''}</td>
                        <td>{moment(request.targetHireDate).format("MM/DD/YYYY")}</td>
                        <td>{request.positionTitle}</td>
                        <td>{request.positionLocation}</td>
                        <td>{request.companyName}</td>
                        <td>{request.office}</td>
                        <td>{request.officeName}</td>
                        <td>{request.deptHeadCount}</td>
                        <td>{request.division}</td>
                        <td>{request.hiringManagerFullName}</td>
                        <td>{request.reportToFullName}</td>
                        <td>{request.statusDescription}</td>
                        <td>{icon}</td>
                        <td className={this.props.role != 'supervisor' ? "ap-hidden" : ""}><span name={request.requestID} onClick={(event) => { if (enableEdit == true) this.onEditClick(event); }}  className={"fa fa-edit " + (enableEdit == true ? 'ap-green-color' : 'ap-gray-color' )}/></td>
                        <td className={this.props.role != 'supervisor' ? "ap-hidden" : ""}><span name={request.requestID} onClick={this.onCopyClick} className="fa fa-clone ap-green-color"/></td>
                    </tr>);        
            }
        }

        return(
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <td><a href="#" onClick={this.onHeaderClick} type="R.RequestID">{this.state.resources.reqNumHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="RequestedDate">{this.state.resources.dateRequestedHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="R.TargetHireDate">{this.state.resources.targetHireDateHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="R.PositionTitle">{this.state.resources.positionTitleHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="PositionLocation">{this.state.resources.positionLocationHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="C.description">{this.state.resources.companyHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="R.Office">{this.state.resources.officeNumHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="O.description">{this.state.resources.officeNameHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="R.DeptHeadCount">{this.state.resources.deptHeadCountHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="R.Division">{this.state.resources.divCoSectorHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="HiringManagerFullName">{this.state.resources.hiringManagerHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="R.ReportToFullName">{this.state.resources.reportsToHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="R.Status">{this.state.resources.statusHeader}</a></td>
                                    <td><a href="#" onClick={this.onHeaderClick} type="R.Status"></a></td>
                                    <td className={this.props.role != 'supervisor' ? "ap-hidden" : ""}>{this.state.resources.edit}</td>
                                    <td className={this.props.role != 'supervisor' ? "ap-hidden" : ""}>{this.state.resources.copy}</td>
                                </tr>
                            </thead>
                            <tbody>
                                {items}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Paginator total={totalPage} range="3" selectedIndex={vm.page} 
                            onNavigate={this.props.onNavigate}  />
                    </div>
                </div>
            </div>
        );
    }
}